import { useEffect, useState } from 'react';
import { GetServerSideProps } from 'next';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ShareCompoment from '@/components/Ambassador/Share';
import { ReferralProvider } from '@/components/Ambassador/ReferralProvider';
import SEOlinksA from '@/components/SEOlinksA';
import efBridge from '@/utils/JSBridge';
import { onLogin } from '@/utils/cookie';
import { getAppSession } from '@/utils/appGetToken';

type Prop = {
    SEO?: any;
    isLogin: boolean;
};

const EcoflowAmbassadorProgram: React.FC<Prop> = ({ SEO, isLogin }) => {
    const { useLang, useRouter, isApp } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');
    const [login, setLogin] = useState(isLogin);

    const initInfo = () => {
        efBridge.init();
        // 设置app导航
        efBridge?.callHandler('setPageConfig', {
            showNav: 1, // 显示导航栏
            topStartFrom: 0, // 在导航栏以下显示H5
            navigationBarBackgroundColor: '#000', //设置背景色
            navigationBarTextColor: '#FFFFFF', // 设置导航栏字体色,
        });
        if (isApp) {
            setLogin(true);
            // efBridge.registerHandler('getAppMsg', (res) => {
            //     if (!res) return;
            //     const dataSet = {
            //         token: res.token.replace('Bearer ', ''),
            //         user: {},
            //     };
            //     onLogin(dataSet);
            // });
            const token = getAppSession();
            const dataSet = {
                token,
                user: {},
            };
            onLogin(dataSet);
        }
    };

    useEffect(() => {
        initInfo();
    }, []);

    return (
        <>
            <SEO title={t('seo.title')} description={t('seo.desc')} />
            <SEOlinksA locale={locale} list={['de']} pathname={'ecoflow-botschafter-programm'} />
            <PageLayout hideFooter={isApp} hideHeader={isApp}>
                <ReferralProvider>
                    <ShareCompoment isLogin={login} />
                </ReferralProvider>
            </PageLayout>
        </>
    );
};

export default EcoflowAmbassadorProgram;

export const getServerSideProps: GetServerSideProps = async ({ locale, req }) => {
    const whiteLocaleList = ['de'];
    if (!whiteLocaleList.includes(locale as string)) {
        return { notFound: true };
    }
    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    return {
        props: {
            isLogin,
        },
    };
};
